import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Seo from './components/Seo'
import Home from './pages/Home'
import Projects from './pages/Projects'
import Publications from './pages/Publications'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import About from './pages/About'
import Contact from './pages/Contact'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Images from './pages/Images'
import Videos from './pages/Videos'
import Login from './pages/Login'
import Notes from './pages/Notes'
import NotFound from './pages/NotFound'
import AdminCalendar from './pages/AdminCalendar'
import YearlyOverview from './pages/YearlyOverview'
import PublicCalendar from './pages/PublicCalendar'
import CV from './pages/CV'
import ProtectedRoute from './components/ProtectedRoute'

const CHROMELESS_PREFIXES = ['/admin/calendar']

const PERSON_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Dristanta Silwal',
  url: 'https://dristantasilwal.com.np',
  jobTitle: 'Graduate Research Assistant',
  sameAs: [
    'https://github.com/dristanta-silwal',
    'https://linkedin.com/in/dristantasilwal',
    'https://twitter.com/DristantaSilwal',
    'https://dristantasilwal.hashnode.dev/',
  ],
}

function AppWrapper() {
  const location = useLocation()
  const isChromeless = CHROMELESS_PREFIXES.some((prefix) => location.pathname.startsWith(prefix))

  return (
    <>
      {!isChromeless && <Navbar />}
      <Routes>
        <Route path="/" element={<>
          <Seo title="Dristanta Silwal — Portfolio" description="Dristanta Silwal — Graduate Research Assistant. Portfolio featuring research projects, publications, and writing." canonicalPath="/" jsonLd={PERSON_JSON_LD} />
          <Home />
        </>} />
        <Route path="/projects" element={<>
          <Seo title="Projects — Dristanta Silwal" description="Research and engineering projects by Dristanta Silwal, including tools, models, and demos." canonicalPath="/projects" />
          <Projects />
        </>} />
        <Route path="/publications" element={<>
          <Seo title="Publications — Dristanta Silwal" description="Academic publications and research papers by Dristanta Silwal, Graduate Research Assistant." canonicalPath="/publications" />
          <Publications />
        </>} />
        <Route path="/blog" element={<>
          <Seo title="Blog — Dristanta Silwal" description="Writing on research, engineering, and ideas by Dristanta Silwal." canonicalPath="/blog" />
          <Blog />
        </>} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<>
          <Seo title="About — Dristanta Silwal" description="About Dristanta Silwal, Graduate Research Assistant." canonicalPath="/about" jsonLd={PERSON_JSON_LD} />
          <About />
        </>} />
        <Route path="/contact" element={<>
          <Seo title="Contact — Dristanta Silwal" description="Get in touch with Dristanta Silwal." canonicalPath="/contact" />
          <Contact />
        </>} />
        <Route path="/images" element={<>
          <Seo title="Photos — Dristanta Silwal" description="Photo gallery by Dristanta Silwal." canonicalPath="/images" />
          <Images />
        </>} />
        <Route path="/videos" element={<>
          <Seo title="Videos — Dristanta Silwal" description="Video gallery by Dristanta Silwal." canonicalPath="/videos" />
          <Videos />
        </>} />
        <Route path="/login" element={<>
          <Seo title="Login — Dristanta Silwal" noindex canonicalPath="/login" />
          <Login />
        </>} />
        <Route path="/calendar" element={<>
          <Seo title="Availability — Dristanta Silwal" description="Check availability and book time with Dristanta Silwal." canonicalPath="/calendar" />
          <PublicCalendar />
        </>} />
        <Route
          path="/admin/calendar"
          element={<ProtectedRoute><><Seo title="Admin — Dristanta Silwal" noindex canonicalPath="/admin/calendar" /><AdminCalendar /></></ProtectedRoute>}
        />
        <Route
          path="/admin/calendar/yearly"
          element={<ProtectedRoute><><Seo title="Admin — Dristanta Silwal" noindex canonicalPath="/admin/calendar/yearly" /><YearlyOverview /></></ProtectedRoute>}
        />
        <Route path="/notes" element={<ProtectedRoute><><Seo title="Notes — Dristanta Silwal" noindex canonicalPath="/notes" /><Notes /></></ProtectedRoute>} />
        <Route path="/CV" element={<>
          <Seo title="CV — Dristanta Silwal" description="Curriculum vitae of Dristanta Silwal, Graduate Research Assistant." canonicalPath="/CV" />
          <CV />
        </>} />
        <Route path="*" element={<>
          <Seo title="Page Not Found — Dristanta Silwal" noindex canonicalPath="/404" />
          <NotFound />
        </>} />
      </Routes>
      {!isChromeless && <Footer />}
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  )
}

export default App